"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BotaoVoltarAppAluno = void 0;
var utils_frontend_1 = require("@aura/utils-frontend");
var react_1 = __importDefault(require("react"));
var botao_voltar_component_1 = require("../botao-voltar/botao-voltar.component");
var BotaoVoltarAppAluno = function (_a) {
    var className = _a.className, bgColor = _a.bgColor;
    var isAppEmbarcado = (0, utils_frontend_1.useAppEmbarcado)().isAppEmbarcado;
    if (isAppEmbarcado) {
        return (react_1.default.createElement(botao_voltar_component_1.BotaoVoltar, { id: "btn-voltar-app-aluno", ariaLabel: "Voltar para o app", className: className, onClick: function () {
                window.ReactNativeWebView.postMessage('{"method": "backButtonPressed"}');
            }, bgColor: bgColor }));
    }
    return react_1.default.createElement(react_1.default.Fragment, null);
};
exports.BotaoVoltarAppAluno = BotaoVoltarAppAluno;
